import { useTheme } from "@/context/ThemeContext";
import { Moon, Sun } from "lucide-react";

/**
 * Beem — Toggle claro/oscuro con rotación.
 * Un pill de dos "espacios" con thumb que se desliza y voltea el icono.
 */
export default function ThemeToggle({ className = "" }) {
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";
  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={isDark ? "Cambiar a modo claro" : "Cambiar a modo oscuro"}
      title={isDark ? "Modo claro" : "Modo oscuro"}
      data-testid="theme-toggle"
      className={`relative inline-flex items-center h-8 w-[62px] rounded-full transition-colors ${
        isDark ? "bg-primary/20" : "bg-nude"
      } border border-border/70 ${className}`}
    >
      <span
        className={`absolute top-[3px] w-[26px] h-[26px] rounded-full bg-card shadow-soft-lift transition-all duration-300 ease-out flex items-center justify-center ${
          isDark ? "left-[32px] rotate-[360deg]" : "left-[3px] rotate-0"
        }`}
      >
        {isDark ? (
          <Moon className="w-3.5 h-3.5 text-primary" strokeWidth={2.2} />
        ) : (
          <Sun className="w-3.5 h-3.5 text-primary" strokeWidth={2.2} />
        )}
      </span>
      <Sun className={`absolute left-[9px] w-3 h-3 transition-opacity ${isDark ? "opacity-40 text-muted-foreground" : "opacity-0"}`} />
      <Moon className={`absolute right-[9px] w-3 h-3 transition-opacity ${!isDark ? "opacity-40 text-muted-foreground" : "opacity-0"}`} />
    </button>
  );
}
